import type { AppRouteModule } from '/@/router/types';

import { LAYOUT } from '/@/router/constant';

const examineFlow: AppRouteModule = {
  path: '/data-duplication-check',
  name: 'DataDuplicationCheck',
  component: LAYOUT,
  redirect: '/data-duplication-check/index',
  meta: {
    icon: 'ic:baseline-approval',
    title: '数据查重',
    hideMenu: true,
  },
  children: [
    {
      path: 'index',
      name: 'DataDuplicationCheckIndex',
      component: () => import('/@/views/admin/data-duplication-check/index.vue'),
      meta: {
        title: '数据查重',
        ignoreKeepAlive: false,
        affix: true,
      },
    },
  ],
};

export default examineFlow;
